<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils title="Market Place"/>
      <div style="display: flex;align-items: center;justify-content: space-between">
        <breadcrumb :items="[{label: 'Market Place', path: '/market_places'}]"/>
        <div>
          <div class="checkbox-inline" style="padding: 5px">
            <label style="cursor: pointer; user-select: none">
              Mostrar cliente?&nbsp;&nbsp;&nbsp;
              <input type="checkbox"
                     v-model="isShowCustomer"
                     class="checkbox green m"/></label>
          </div>
        </div>
      </div>

      <div class="container-fluid-grid">
        <div class="row">
          <div class="col-12">
            <div class="tbl-responsive">
              <table class="tbl">
                <thead>
                <tr>
                  <th class="t-c" style="width: 10%">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Produto"
                               v-model="productFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="product.name"/>
                    </div>
                  </th>
                  <th v-if="isShowCustomer" class="t-c" style="width: 10%">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Cliente"
                               v-model="customerFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="customer.commercial_name"/>
                    </div>
                  </th>
                  <th class="t-c">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Volume"
                               v-model="volumeFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="quantity"/>
                    </div>
                  </th>
                  <th class="t-c">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Preço"
                               v-model="priceFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="price"/>
                    </div>
                  </th>
                  <th class="t-c">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Execução"
                               v-model="executionFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="shipment_log"/>
                    </div>
                  </th>
                  <th class="t-c ellipsis">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Local"
                               v-model="localFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="city.name"/>
                    </div>
                  </th>
                  <th class="t-c" style="width: 20%">
                    <div class="c-n">
                      <span class="ellipsis">
                        <input type="search"
                               placeholder="Obs"
                               v-model="notesFilter"
                               class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="notes"/>
                    </div>
                  </th>
                  <th class="t-c">
                    <div class="c-n">
                      <span class="ellipsis">
                      <input type="search"
                             placeholder="Corretor"
                             v-model="brokerFilter"
                             class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="broker.name"/>
                    </div>
                  </th>
                  <th class="t-c">
                    <div class="c-n">
                      <span class="ellipsis">
                      <input type="search"
                             placeholder="TSC"
                             title="Tempo sem contrato"
                             v-model="tscFilter"
                             class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="last_proposal.human_time"/>
                    </div>
                  </th>
                  <th class="t-c">
                    <div class="c-n">
                      <span class="ellipsis">
                      <input type="search"
                             placeholder="Atualização"
                             v-model="updateFilter"
                             class="header-filter plch-center">
                      </span>
                      <SortColumn @changeOrder="onChangeOrderBuyer"
                                  :source="buyerOrder"
                                  column-name="updated_at"/>
                    </div>
                  </th>
                </tr>
                </thead>
                <transition-group tag="tbody" name="tbl-row">
                  <tr v-for="(s, index) in orderedBuyers"
                      :key="index"
                      @click="change(s)"
                      :class="{active: s.id === lastUpdateId, 'price-zero': s.price <= 0}"
                      class="c-p line-item">
                    <td class="ellipsis product-color" :title="s.product.name">
                      <span class="color-badge" :style="{
                        backgroundColor: `rgb(${productColors[s.product.id].color})`
                      }"/>
                      {{ s.product.name }}
                    </td>
                    <td v-if="isShowCustomer" class="ellipsis v-m seller-type"
                        :title="`${s.is_seller ? 'Vendedor' : 'Comprador'} ${s.customer.name}`">
                      <span :class="{'color-badge': true, buyer: !s.is_seller, seller: s.is_seller}"/>
                      {{ s.customer.group ? s.customer.group.name : s.customer.commercial_name }}
                      ({{ s.is_seller ? 'v' : 'c' }})
                    </td>
                    <td class="t-r ellipsis">{{ s.quantity | formatNumber(0, '', '.') }}</td>
                    <td class="t-r ellipsis" style="overflow: visible!important;">
                      <span v-if="s.price_histories.length > 1">
                      <HoverTooltip max-height="250px">
                        <span class="f-w-700" style="cursor: help">{{ s.price | formatMoney }}</span>
                        <template #tooltip-content>
                          <h4 class="t-l">Histórico de preço</h4>
                          <ul class="t-l" style="margin: 0;padding: 0;list-style: none">
                            <li class="t-l" v-for="(ph, idx) in s.price_histories" :key="idx">
                              R$ {{ph.price | formatMoney}} - {{ph.created_at | formatDate('DD/MM/YYYY HH:mm')}}
                            </li>
                          </ul>
                        </template>
                      </HoverTooltip>
                      </span>
                      <span v-else>
                        {{ s.price | formatMoney }}
                      </span>
                    </td>
                    <td class="t-c ellipsis">
                      {{ showDate(index) }}
                    </td>
                    <td class="ellipsis" :title="s.city.name">{{ s.city.name }}/{{ s.city.state.acronym }}</td>
                    <td class="p-r o-h ellipsis" :title="s.notes">
                      {{ s.notes }}
                    </td>
                    <td class="p-r o-h ellipsis" :title="showBrokerName(index)">
                      {{ showBrokerName(index) }}
                    </td>
                    <td class="p-r o-h" style="overflow: visible!important;">
                      <span v-if="s.last_proposal.human_time !== ''">
                      <HoverTooltip max-height="250px">
                        <span class="f-w-700 ellipsis" style="cursor: help;display: inline-block;max-width: 100px;">{{ s.last_proposal.human_time }}</span>
                        <template #tooltip-content>
                          <h4 class="t-l">Dados do contrato</h4>
                          <p style="min-width: 300px">
                            <b>Número:</b> <router-link :to="{path: `/proposals/${s.last_proposal.id}/edit`}"
                                                        target="_blank"
                                                        title="Ver contrato">
                              {{ s.last_proposal.number }}
                            </router-link><br/>
                            <b>Preço:</b> {{ s.last_proposal.price | formatMoney }}<br/>
                            <b>Quantidade:</b> {{ s.last_proposal.quantity }}<br/>
                          </p>
                        </template>
                      </HoverTooltip>
                      </span>
                      <span class="ellipsis" v-else>
                        {{ s.last_proposal.human_time }}
                      </span>
                    </td>
                    <td class="t-c p-r o-h">
                      <div class="ellipsis">{{ s.updated_at | formatDateHourMin }}</div>
                      <div class="actions btn-group btn-group-xs">
                        <button type="button"
                                @click="confirmDestroy(s.id, $event)" class="btn btn-xs btn-danger">
                          <svg-icon icon="trash-alt"/>
                        </button>
                      </div>
                    </td>
                  </tr>
                </transition-group>
                <tbody v-if="orderedBuyers.length === 0">
                <tr>
                  <td class="t-c" colspan="9">Não há ofertas de compradores</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <transition name="tab" mode="out-in">
          <div class="row" v-if="lastUpdate" :key="`last_${lastUpdate.id}`">
            <div class="col-12 t-c">
              <div class="badge-last"
                   v-ripple-tap
                   @click="showLast"
                   @mouseover="lastUpdateId = lastUpdate.id"
                   @mouseout="lastUpdateId = null">
                <b>{{ lastUpdate.user_update ? lastUpdate.user_update.name : lastUpdate.user_create.name }}</b> alterou
                <span
                    :title="lastUpdate.updated_at | formatDate('DD/MM/YYYY HH:mm:ss')">{{
                    lastUpdate.updated_distance
                  }}</span>
                atrás
              </div>
            </div>
          </div>
        </transition>
      </div>
      <Fab type="button"
           icon="plus"
           size="normal"
           @click="showModal"
           color="blue"/>
    </template>
  </DefaultTmpl>
</template>

<script>
import DefaultTmpl from "@/templates/DefaultTmpl"
import {EventBus} from "@/utils/EventBus"
import {createNamespacedHelpers} from 'vuex'
import orderBy from 'lodash/orderBy'
import SortColumn from "@/components/particles/SortColumn"
import HoverTooltip from "@/components/particles/HoverTooltip.vue";
import Fab from "@/components/particles/Fab"

const {mapActions, mapGetters} = createNamespacedHelpers('market_places');
const _MARKET_PLACES_ORDER = '_MARKET_PLACES_ORDER';


export default {
  name: "MarketPlacesSearch",
  components: {SortColumn, DefaultTmpl, Fab, HoverTooltip},
  data() {
    return {
      sellerOrder: {},
      buyerOrder: {},
      lastUpdateId: null,
      showLastTimeout: null,
      isShowCustomer: true,
      productFilter: '',
      customerFilter: '',
      volumeFilter: '',
      priceFilter: '',
      executionFilter: '',
      localFilter: '',
      notesFilter: '',
      updateFilter: '',
      brokerFilter: '',
      tscFilter: '',
    }
  },
  methods: {
    ...mapActions(['filter', 'destroy']),
    showModal() {
      EventBus.showMarketPlace();
    },
    onChangeOrderSeller(ordering) {
      this.orderChange(true, ordering);
    },
    onChangeOrderBuyer(ordering) {
      this.orderChange(false, ordering);
    },
    orderChange(isSeller = true, ordering) {
      const name = isSeller ? 'sellerOrder' : 'buyerOrder';
      if (ordering.order) {
        this.$set(this[name], ordering.columnName, ordering.order)
      } else {
        this.$delete(this[name], ordering.columnName)
      }
    },
    sortCustomer(customers = {}, order) {
      const keys = Object.keys(order);

      let result = Object.keys(customers).map(k => customers[k]);
      if (keys.length > 0) {
        const values = Object.values(order);
        result = orderBy(result, keys, values);
      }

      return result;
    },
    change(mp) {
      EventBus.showMarketPlace(() => {
      }, {entity: mp});
    },
    confirmDestroy(idItem, e) {
      e.preventDefault();
      e.stopPropagation();

      this.$store.commit('addModal', {
        title: this.$t('common.destroyItemTitle'),
        size: 'small',
        body: 'Deseja realmente remover o Market Place?',
        buttons: [
          {
            type: 'ok', class: 'btn btn-danger btn-sm', method: id => {
              this.$store.commit('destroyModal', id);
              const self = this;
              this.destroy(idItem)
                  .then(() => self.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name))
                  .catch(() => self.$snotify.error(this.$t('common.destroyItemError'), this.$appStorage.getUser().name))
            }
          },
          {type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)}
        ]
      })
    },
    showLast() {
      clearTimeout(this.showLastTimeout);
      this.showLastTimeout = setTimeout(() => this.change(this.lastUpdate), 150);
    },
    showBrokerName(index) {
      const mp = this.orderedBuyers[index];

      if (mp.broker) return mp.broker.name;

      return '';
    },
    showDate(index) {
      const mp = this.orderedBuyers[index];

      const result = [this.$appUtils.formatDate(mp.shipment_log_start_at, 'MMMM/YY')];

      if (mp.shipment_log_end_at) {
        result.push(' - ', this.$appUtils.formatDate(mp.shipment_log_end_at, 'MMMM/YY'));
      }

      return result.join('')
    }
  },
  computed: {
    ...mapGetters(['sellers', 'buyers', 'lastUpdate']),
    orderedBuyers() {
      let array = this.sortCustomer({...this.buyers, ...this.sellers}, this.buyerOrder)

      if (!this.$appUtils.isEmpty(this.productFilter)) {
        array = array.filter(mp => mp.product.name.toLowerCase().includes(this.productFilter.toLowerCase()))
      }

      if (!this.$appUtils.isEmpty(this.customerFilter)) {
        array = array.filter(mp => {
          let name = mp.customer.group ? mp.customer.group.name : mp.customer.commercial_name;
          name += ` (${mp.is_seller ? 'v' : 'c'})`
          return this.$appUtils.compareTexts(name, this.customerFilter)
        })
      }

      if (!this.$appUtils.isEmpty(this.volumeFilter)) {
        array = array.filter(mp => mp.quantity.toString().includes(this.volumeFilter))
      }

      if (!this.$appUtils.isEmpty(this.priceFilter)) {
        array = array.filter(mp => mp.price.toString().includes(this.priceFilter))
      }

      if (!this.$appUtils.isEmpty(this.executionFilter)) {
        array = array.filter(mp => this.$appUtils.compareTexts(mp.shipment_log_label, this.executionFilter));
      }

      if (!this.$appUtils.isEmpty(this.localFilter)) {
        array = array.filter(mp => this.$appUtils.compareTexts(mp.city.name, this.localFilter))
      }

      if (!this.$appUtils.isEmpty(this.notesFilter)) {
        array = array.filter(mp => this.$appUtils.compareTexts(mp.notes, this.notesFilter))
      }

      if (!this.$appUtils.isEmpty(this.brokerFilter)) {
        array = array.filter(mp => this.$appUtils.compareTexts(mp.broker ? mp.broker.name : '', this.brokerFilter))
      }

      if (!this.$appUtils.isEmpty(this.tscFilter)) {
        array = array.filter(mp => this.$appUtils.compareTexts(mp.last_proposal.human_time, this.tscFilter))
      }

      if (!this.$appUtils.isEmpty(this.updateFilter)) {
        array = array.filter(mp => this.$appUtils.formatDate(mp.updated_at).toLowerCase().includes(this.updateFilter.toLowerCase()))
      }

      return array
    },
    productColors() {
      const allProducts = Object.values({...this.buyers, ...this.sellers})

      const products = allProducts
          .sort((a, b) => a.product.name.localeCompare(b.product.name))
          .map(mp => mp.product)
          .reduce((acc, p) => {
            if (!acc[p.id]) acc[p.id] = p;
            return acc;
          }, {});

      const colors = [...Object.keys(this.$appUtils.COLOR_RANGE)];
      this.$appUtils.fillRandomRGB(colors, products.length)

      Object.keys(products).forEach((k, idx) => {
        products[k].color = colors[idx];
      });

      return products;
    }
  },
  beforeMount() {
    const saved = this.$appStorage.getObject(_MARKET_PLACES_ORDER);

    if (saved && saved.sellerOrder && saved.buyerOrder) {
      this.sellerOrder = saved.sellerOrder;
      this.buyerOrder = saved.buyerOrder;
    }

    this.filter({});
  },
  destroyed() {
    this.$appStorage.saveObject(_MARKET_PLACES_ORDER, {sellerOrder: this.sellerOrder, buyerOrder: this.buyerOrder});
  }
}
</script>


<style scoped lang="scss">
@import "../../assets/css/scrollbar";
@import "../../assets/css/variables";

.tbl {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1em;
  border-collapse: collapse;
  font-size: 1em;
  table-layout: fixed;

  tbody tr {
    transition: background-color .5s ease;
    &:nth-child(odd) {
      background-color: #f6f6f6;
    }

    &.price-zero {
      color: $fixed_expenses_main_color
    }

    &:hover {
      -webkit-box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
      box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
    }
  }

  thead th {
    background-color: $theme_color_one;
  }

  th {
    background-color: $theme_color_eleven;
    color: $theme_color_three;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    user-select: none;
  }

  th, td {
    padding: .1rem .2rem;
    border: 1px solid #e6e6e6;
  }

  tr.active {
    background-color: $theme_color_eleven;
  }
}

.seller-type, .product-color {
  position: relative;
  padding-left: 8px !important;

  > .color-badge {
    display: inline-block;
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
  }
}

.seller-type {
  > .seller {
    background-color: $market_place_seller;
  }

  > .buyer {
    background-color: $market_place_buyer;
  }
}

@media (max-width: 767.98px) {
  .tbl-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .tbl {
      table-layout: auto;
    }
  }
}

.c-n {
  display: grid;
  grid-template-columns: auto 1.5em;
  justify-items: center;
  align-items: center;
  overflow: hidden;
}

.tbl-row-enter-active, .tbl-row-leave-active {
  transition: opacity .3s ease-in-out;
}

.tbl-row-enter, .tbl-row-leave-to {
  opacity: 0;
}

.badge-last {
  display: inline-block;
  border-radius: 6px;
  padding-right: 15px;
  padding-left: 15px;
  cursor: pointer;
  transition: background-color .3s ease;
  background-color: $theme_color_one;
  margin-top: 40px;
}

.header-filter {
  border: none;
  outline: none;
  background-color: transparent;
  text-align: center;
  width: 100%;
  text-transform: uppercase;
  font-weight: 700;

  &::placeholder {
    color: #000;
    opacity: 1;
    &:focus {
      color: lightgrey;
    }
  }
}

</style>
